import Link from 'next/link';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { LotteryEventTag } from '../../types';
import styles from './LotteryTagList.module.scss';

export type LotteryTagListProps = {
  tags: Array<LotteryEventTag>;
};

function LotteryTagList({ tags }: LotteryTagListProps) {
  return (
    <ul className={styles.componentStyle}>
      {tags.map((tag) => (
        <li key={`tags_${tag.id}`}>
          <Link href={`/lotteries?tag=${tag.id}`} className={`${styles.itemLink} ${utilsStyles.textBold}`}>
            #{tag.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}

export default LotteryTagList;
